import { lifecycle } from 'recompose';
import ReactTooltip from 'react-tooltip';
import debounce from "../../util/debounce";
var rebuildTooltips = debounce(ReactTooltip.rebuild, 400);
var rebuildTooltipsHOC = lifecycle({
  componentDidMount: function componentDidMount() {
    rebuildTooltips();
  },
  componentDidUpdate: function componentDidUpdate() {
    rebuildTooltips();
  }
});
export default rebuildTooltipsHOC;